import React from "react";

import withWebHistoryList from "../../../../../hocs/withHistoryList/withWebHisotryList";
import InterestingStocksListItem from "../../InterestingStocksListItem";
import Loader from "../../Loader";
import SquaberButton from "../../SquaberButton";

const InterestingStocksList = ({
  historyListState,
  fetchNextPage,
  translate
}) => (
  <div className="history-list">
    {historyListState.loading ? (
      <Loader small />
    ) : (
      <React.Fragment>
        {historyListState.data.results.map((signal, index) => (
          <InterestingStocksListItem key={index} {...signal} />
        ))}
        {historyListState.data.next ? (
          <div className="text-center load-more-button-wrapper">
            <SquaberButton
              color="tertiary"
              onClick={async () => {
                await fetchNextPage();
              }}
              disabled={historyListState.loadingNextPage}
            >
              {translate("Load more stocks")}
              {historyListState.loadingNextPage ? (
                <i className="fal fa-spinner fa-spin" />
              ) : null}
            </SquaberButton>
          </div>
        ) : null}
      </React.Fragment>
    )}
  </div>
);

InterestingStocksList.propTypes = {};

export default withWebHistoryList("tpsl-signals")(InterestingStocksList);
